import { render, staticRenderFns } from "./MobileCardLine.vue?vue&type=template&id=4fae6c18&scoped=true"
import script from "./MobileCardLine.vue?vue&type=script&lang=js"
export * from "./MobileCardLine.vue?vue&type=script&lang=js"
import style0 from "./MobileCardLine.vue?vue&type=style&index=0&id=4fae6c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae6c18",
  null
  
)

export default component.exports